import React, { use, useContext, useEffect, useRef, useState } from 'react';
import { Row, Col, Stack } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import 'assets/styles/common.scss';
import { LocaleContext } from 'routes/Router';
import 'Pages/SuperAdmin/Dashboard/dashboard.scss';
import rightArrow from 'assets/images/Dashboard/arrow-right.png';
import addIcon from 'assets/images/Dashboard/add.png';
import mail from 'assets/images/Dashboard/mail.png';
import call from 'assets/images/Dashboard/call.png';
import trash from 'assets/images/Dashboard/trash.png';
import ReusableTabs from 'components/common/Tabs';
import { FormattedMessage, useIntl } from 'react-intl';
import ReusableButton from 'components/common/Button';
import {
  providerAdminAddSpecialists,
  providerAdminViewForm,
  superAdminCompanyProviderDetails,
  superAdminSalonProviderDetails,
  superAdminSpecialistProviderDetails,
} from 'routes/AppUrls';
import SwitchInput from 'components/common/Input/SwitchInput';
import { getUserRole } from 'utils/general';
import SelectInput from 'components/common/Input/SelectInput';
import LabelWithInput from 'components/common/Input/LabelWithInput';
import InputAdornment from '@mui/material/InputAdornment';
import searchIcon from 'assets/images/navbar/search.svg';
import crossIcon from 'assets/images/provider/crossIcon.png';
import { getSpecialistProviderCallAPI } from 'store/ProviderAdmin/getSpecialistProvider/action';
import { useDispatch, useSelector } from 'react-redux';
import { getCompanyBranchProviderCallAPI } from 'store/ProviderAdmin/getCompanyBranchProvider/action';
import moment from 'moment';
import { updateSpecialistStatusProviderCallAPI } from 'store/ProviderAdmin/statusUpdateSpecialistProvider/action';
import ToastNotification from 'components/common/Toast';
import { cancelSpecialistInvitationCallAPI } from 'store/ProviderAdmin/cancelSpecialistInvitation/action';
import {
  basicDetailsCallApi,
  SPECIALIST_ID,
  SPECIALIST_SELECTED_TAB,
} from 'store/SuperAdmin/basicDetails/action';
import Lottie from 'lottie-react';
import animationData from 'assets/Lottie/no_data.json';
import { useConfirm } from 'material-ui-confirm';
import CustomPopover from 'components/common/CustomPopover';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { fileUploadCallAPI } from 'store/FileUpload/action';
import CircularProgress from '@mui/material/CircularProgress';
import { resendInvitationCallAPI } from 'store/ProviderAdmin/resendInvitation/action';
import { ShimmerBox, ShimmerCircle } from 'components/common/Shimmer';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { setPageTitle } from 'store/pageTitle/action';

const ProviderAdminSpecialists = () => {
  const navigate = useNavigate();
  const userRole = getUserRole();
  const intl = useIntl();
  const [conf, setConf] = ToastNotification();
  const dispatch = useDispatch();
  const { locale } = useContext(LocaleContext);
  const confirm = useConfirm();
  const [anchorEl, setAnchorEl] = useState(null);
  const [viewData, setViewData] = useState('');
  const fileInputRef = useRef();
  const [sortField, setSortField] = useState('');
  const [sortOrder, setSortOrder] = useState('asc');

  const getSpecialistSelectedTab = useSelector(
    (state) => state?.basicDetailsReducer?.spcialistSelectedTab
  );
  const [tab, setTab] = useState(getSpecialistSelectedTab);
  const profileData = useSelector((state) => state?.userMeReducer?.data?.data);
  const getBranchListData = useSelector(
    (state) => state?.getCompanyBranchProviderReducer?.data?.data
  );
  const getSpecialistListData = useSelector(
    (state) => state?.getCompanyBranchProviderReducer?.data?.data
  );
  const specialistLoading = useSelector(
    (state) => state?.getSpecialistProviderReducer?.loading
  );
  const branchLoading = useSelector(
    (state) => state?.getCompanyBranchProviderReducer?.loading
  );
  const fileUploadLoader = useSelector(
    (state) => state?.fileUploadReducer?.loading
  );
  const [specialistList, setSpecialistList] = useState(
    getSpecialistListData ?? []
  );
  const [originalSpecialistList, setOriginalSpecialistList] = useState(
    getSpecialistListData ?? []
  );
  const [branchId, setBranchId] = useState(
    getBranchListData?.length > 0 ? getBranchListData?.[0]?.id : ''
  );

  const [formValue, setFormValue] = useState({
    branch:
      getBranchListData?.length > 0
        ? getBranchListData?.[0]?.searched_business_name_en
        : '',
  });
  const [searchValue, setSearchValue] = useState('');

  const PopoverData = [
    {
      label: <FormattedMessage id="Edit" />,
      icon: '',
      onClick: () => {
        handleEdit();
      },
    },
    {
      label: <FormattedMessage id="Resend" />,
      icon: '',
      onClick: () => {
        handleResend();
      },
    },
  ];

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  useEffect(() => {
    userRole === 'company-admin' ? getBranchList() : getSpecialistsList();
  }, []);

  useEffect(() => {
    dispatch(setPageTitle('Specialists'));
  }, []);

  const getBranchList = () => {
    dispatch(
      getCompanyBranchProviderCallAPI(
        {},
        {
          run: true,
          handleFunction: (res) => handleBranchSucess(res),
          navigate: navigate,
        }
      )
    );
  };

  const handleBranchSucess = (res) => {
    getSpecialistsList(res?.data?.data?.[0]?.id);
    setFormValue({
      ...formValue,
      ['branch']: res?.data?.data?.[0]?.searched_business_name_en,
    });
    setBranchId(res?.data?.data?.[0]?.id);
  };

  const getSpecialistsList = (branchSelectedId = '', tabValue = tab) => {
    dispatch(
      getSpecialistProviderCallAPI(
        {},
        {
          id:
            userRole === 'company-admin'
              ? branchSelectedId || branchId
              : profileData?.provider_details?.id,
          type: tabValue === 1 ? 'onboarded' : 'not_onboarded',
          run: true,
          handleFunction: (res) => handleSuccess(res),
          navigate: navigate,
        }
      )
    );
  };

  const handleSuccess = (res) => {
    setSpecialistList(res?.data?.data);
    setOriginalSpecialistList(res?.data?.data);
  };

  const handleSwitchChange = (data) => {
    let body = {
      employee_id: data?.id,
      employee_status:
        data?.invite_status === 'specialist-activated'
          ? 'specialist-deactivated'
          : 'specialist-activated',
    };
    dispatch(
      updateSpecialistStatusProviderCallAPI(body, {
        id:
          userRole === 'company-admin'
            ? branchId
            : profileData?.provider_details?.id,
        run: true,
        handleFunction: (res) => handleUpdateStatus(res),
        navigate: navigate,
        toast: true,
        handleToastError: (res) => handleRedirectError(res),
      })
    );
  };

  const handleUpdateStatus = (res) => {
    setConf({
      msg: res?.data?.message,
      variant: 'success',
    });
    getSpecialistsList(branchId);
  };

  const handleRedirectError = (res) => {
    setConf({
      msg: res?.data?.message,
      variant: 'error',
    });
  };

  const tabData = [
    { label: intl.formatMessage({ id: 'Employees' }) },
    { label: intl.formatMessage({ id: 'Pending Onboarding' }) },
  ];

  const handleTabChange = (val) => {
    setTab(val);
    dispatch(basicDetailsCallApi(SPECIALIST_SELECTED_TAB, val));
    getSpecialistsList(branchId, val);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValue({ ...formValue, [name]: value?.searched_business_name_en });
    setBranchId(value?.id);
    getSpecialistsList(value?.id);
  };

  const handleCancelledInvitation = (id) => {
    dispatch(
      cancelSpecialistInvitationCallAPI(
        {},
        {
          id: id,
          run: true,
          handleFunction: (res) => handleUpdateStatus(res),
          navigate: navigate,
        }
      )
    );
  };

  const handleConfirmCancelInvitation = (id) => {
    confirm({
      title: intl.formatMessage({ id: 'Cancel Invitation' }),
      description: intl.formatMessage({
        id: 'Are you sure you want to Cancel Invitation?',
      }),
      confirmationText: intl.formatMessage({ id: 'Yes' }),
      cancellationText: intl.formatMessage({ id: 'No' }),
      dialogProps: { maxWidth: 'xs' },
      confirmationButtonProps: {
        sx: {
          bgcolor: '#292D32',
          color: '#FFFFFF',
          borderRadius: '0px',
          '&:hover': { bgcolor: '#292D32' },
        },
      },
      cancellationButtonProps: {
        sx: {
          bgcolor: 'transparent',
          color: '#292D32',
          borderRadius: '0px',
          border: '1px solid #292D32',
        },
      },
    })
      .then(() => handleCancelledInvitation(id))
      .catch(() => console.log('Deletion cancelled Invitation.'));
  };

  const handlePopoverClick = (event, item) => {
    setAnchorEl(event.currentTarget);
    setViewData(item);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const handleChooseFile = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileUpload = (e) => {
    if (e.target.files[0]) {
      let formData = new FormData();
      formData.append('file', e.target.files[0]);
      dispatch(
        fileUploadCallAPI(formData, {
          navigate: navigate,
          run: true,
          handleFunction: (res) => {
            handleUpdateStatus(res);
          },
          toast: true,
          handleToastError: (res) => {
            handleRedirectError(res);
          },
        })
      );
    }
  };

  const handleResend = () => {
    dispatch(
      resendInvitationCallAPI(viewData?.id, {
        run: true,
        handleFunction: (res) => {
          setConf({
            msg: res?.data?.message,
            variant: 'success',
          });
          handlePopoverClose();
        },
        toast: true,
        handleToastError: (res) => {
          handleRedirectError(res);
          handlePopoverClose();
        },
      })
    );
  };

  const handleEdit = () => {
    dispatch(basicDetailsCallApi(SPECIALIST_ID, viewData?.id));
    navigate(providerAdminAddSpecialists(locale));
  };

  const handleSearch = (searchVal) => {
    setSearchValue(searchVal);
    // Filter specialist list based on search value
    if (searchVal === '') {
      setSpecialistList(originalSpecialistList);
    } else {
      const filteredList = originalSpecialistList?.filter(
        (specialist) =>
          specialist?.name?.toLowerCase()?.includes(searchVal?.toLowerCase()) ||
          specialist?.email
            ?.toLowerCase()
            ?.includes(searchVal?.toLowerCase()) ||
          specialist?.contact_number?.includes(searchVal)
      );
      setSpecialistList(filteredList);
    }
  };

  const handleSearchClear = () => {
    setSearchValue('');
    getSpecialistsList(branchId, tab);
  };

  const handleCopy = (text) => {
    if (!text) return;

    navigator.clipboard.writeText(text);
    setConf({
      msg: 'Copied to clipboard',
      variant: 'success',
    });
  };

  const handleSort = (f) => {
    const isAsc = sortField === f && sortOrder === 'asc';
    const order = isAsc ? 'desc' : 'asc';
    const dir = order === 'asc' ? 1 : -1;

    const sorted = [...specialistList].sort((a, b) => {
      const getVal = (i) =>
        ({
          name: (i?.name || '').toLowerCase(),
          phone: i?.contact_number || '',
        })[f] ?? (i[f] || '').toString().toLowerCase();

      return getVal(a) > getVal(b) ? dir : -dir;
    });

    setSortField(f);
    setSortOrder(order);
    setSpecialistList(sorted);
  };

  const renderSortArrow = (field) => {
    if (sortField !== field) return null;
    const Icon = sortOrder === 'asc' ? ArrowUpwardIcon : ArrowDownwardIcon;
    return <Icon sx={{ fontSize: '16px', ml: 0.5, verticalAlign: 'middle' }} />;
  };

  return (
    <Row className="bc-F2F3F6 m-0 p-0">
      <Col
        className={
          locale === 'en'
            ? 'commonEnContainer lg:ml-left'
            : 'commonArContainer lg:mr-right'
        }
      >
        {/* <h2 className="fc-292D32 fs-32 fw-400 ff-Akkurat_Bold m-0">
          <FormattedMessage id="Specialists" />
        </h2> */}

        <Row className="p-0 mt-3">
          <Col md={12} lg={4} xl={4} xxl={3}>
            <LabelWithInput
              placeholder={intl.formatMessage({
                id: 'Search',
              })}
              label={intl.formatMessage({
                id: 'Search',
              })}
              name="search"
              type="text"
              marginLabelTop="0"
              height="48"
              bgColor="#FFFFFF"
              value={searchValue}
              onChange={(e) => handleSearch(e?.target?.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <img
                      src={searchIcon}
                      alt="search"
                      style={{
                        cursor: 'pointer',
                        height: '20px',
                        width: '20px',
                      }}
                    />
                    {searchValue ? (
                      <img
                        src={crossIcon}
                        alt="clear"
                        width={18}
                        height={18}
                        style={{ cursor: 'pointer', marginLeft: '8px' }}
                        onClick={() => handleSearchClear()}
                      />
                    ) : null}
                  </InputAdornment>
                ),
              }}
            />
          </Col>
          {userRole === 'company-admin' && (
            <Col md={12} lg={4} xl={4} xxl={2}>
              <SelectInput
                marginLabelTop={'0'}
                label={intl.formatMessage({
                  id: 'Filter by branch',
                })}
                placeholder={intl.formatMessage({
                  id: 'Select a branch',
                })}
                height="48"
                name={'branch'}
                value={formValue?.branch}
                data={getBranchListData ?? []}
                onChange={(e) => handleInputChange(e)}
              />
            </Col>
          )}
        </Row>

        <Row className="m-0 p-0 flex justify-between">
          <Col md={12} lg={6} xl={4} className="m-0 p-0 mt-3">
            <ReusableTabs
              tabs={tabData}
              defaultTab={tab}
              currentTab={(val) => handleTabChange(val)}
            />
          </Col>
          {!specialistLoading && !branchLoading && (
            <Col
              md={12}
              lg={6}
              xl={8}
              className={`m-0 p-0 mt-3 text-start ${locale === 'en' ? 'text-lg-end' : 'text-lg-start'}`}
            >
              <input
                ref={fileInputRef}
                type="file"
                accept=".csv, .xlsx"
                disabled={false}
                style={{ display: 'none' }}
                onChange={handleFileUpload}
              />
              <ReusableButton
                fullWidth={false}
                variant="contained"
                color="#F5F5F5"
                fontSize="16px"
                fontWeight="400"
                padding="14px 16px"
                height="48px"
                bgColor="#292D32"
                fontFamily="Akkurat"
                onClick={() => handleChooseFile()}
                className="me-2"
                endIcon={
                  fileUploadLoader && (
                    <CircularProgress
                      style={{
                        color: 'white',
                        width: '20px',
                        height: '20px',
                      }}
                    />
                  )
                }
              >
                <img
                  src={addIcon}
                  alt="icon"
                  style={{ height: '24px', width: '24px' }}
                  className="me-2"
                />
                <FormattedMessage id="Bulk Import" />
              </ReusableButton>
              <ReusableButton
                fullWidth={false}
                variant="contained"
                color="#F5F5F5"
                fontSize="16px"
                fontWeight="400"
                padding="14px 16px"
                height="48px"
                bgColor="#292D32"
                fontFamily="Akkurat"
                onClick={() => {
                  navigate(providerAdminAddSpecialists(locale));
                  dispatch(basicDetailsCallApi(SPECIALIST_ID, null));
                }}
              >
                <img
                  src={addIcon}
                  alt="icon"
                  style={{ height: '24px', width: '24px' }}
                  className="me-2"
                />
                <FormattedMessage id="Invite Specialist" />
              </ReusableButton>
            </Col>
          )}
        </Row>

        {tab === 1 && (
          <>
            <Row className="mt-3 listHeader m-0 p-0 flex items-center">
              <Col lg={2} md={6} sm={12}>
                <p
                  className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold d-flexcursor-pointer"
                  onClick={() => handleSort('name')}
                >
                  <FormattedMessage id="Specialist" />
                  {renderSortArrow('name')}
                </p>
              </Col>
              {userRole === 'company-admin' && (
                <Col lg={2} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold">
                    <FormattedMessage id="Branch" />
                  </p>
                </Col>
              )}
              <Col lg={2} md={6} sm={12}>
                <p
                  className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold d-flex cursor-pointer"
                  onClick={() => handleSort('email')}
                >
                  <FormattedMessage id="Email" />
                  {renderSortArrow('email')}
                </p>
              </Col>
              <Col lg={2} md={6} sm={12}>
                <p
                  className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold d-flex cursor-pointer"
                  onClick={() => handleSort('phone')}
                >
                  <FormattedMessage id="Phone Number" />
                  {renderSortArrow('phone')}
                </p>
              </Col>
              <Col lg={1} md={6} sm={12}>
                <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold">
                  <FormattedMessage id="Joined On" />
                </p>
              </Col>
              <Col lg={1} md={6} sm={12}>
                <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold">
                  <FormattedMessage id="Status" />
                </p>
              </Col>

              <Col
                lg={`${userRole === 'company-admin' ? 2 : 4}`}
                md={6}
                sm={12}
              >
                <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold">
                  <FormattedMessage id="Actions" />
                </p>
              </Col>
            </Row>

            <Row className="bc-FFFFFF m-0 p-0">
              {specialistLoading || branchLoading ? (
                <>
                  {[1, 2, 3, 4, 5].map((item) => (
                    <Row
                      key={item}
                      className="m-0 p-0 flex items-center listAppointment"
                    >
                      <Col lg={2} md={6} sm={12}>
                        <ShimmerBox width="150px" height="14px" />
                      </Col>
                      {userRole === 'company-admin' && (
                        <Col lg={2} md={6} sm={12}>
                          <ShimmerBox width="200px" height="14px" />
                          <ShimmerBox
                            width="180px"
                            height="12px"
                            className="mt-2"
                          />
                        </Col>
                      )}
                      <Col lg={2} md={6} sm={12}>
                        <ShimmerBox width="120px" height="12px" />
                        <ShimmerBox
                          width="100px"
                          height="12px"
                          className="mt-2"
                        />
                      </Col>
                      <Col lg={2} md={6} sm={12}>
                        <ShimmerBox width="100px" height="14px" />
                      </Col>
                      <Col lg={2} md={6} sm={12}>
                        <ShimmerBox width="50px" height="20px" />
                      </Col>
                      <Col
                        lg={`${userRole === 'company-admin' ? 2 : 4}`}
                        md={6}
                        sm={12}
                      >
                        <Stack
                          direction="horizontal"
                          gap={3}
                          className="items-center"
                        >
                          <ShimmerBox width="24px" height="24px" />
                          <ShimmerBox width="100px" height="14px" />
                        </Stack>
                      </Col>
                    </Row>
                  ))}
                </>
              ) : specialistList?.length > 0 ? (
                specialistList.map((key, index) => (
                  <Row className="m-0 p-0 flex items-center listAppointment">
                    <Col lg={2} md={6} sm={12}>
                      <p
                        className="p-0 m-0 fs-14 fc-292D32 fw-400 ff-Akkurat_Bold cursor-pointer"
                        onClick={() => handleCopy(key?.name)}
                        title="Click to copy"
                      >
                        {key?.name}
                      </p>
                    </Col>

                    {userRole === 'company-admin' && (
                      <Col lg={2} md={6} sm={12}>
                        <p className="p-0 m-0 fs-14 fc-292D32 fw-400 ff-Akkurat_Bold">
                          {'Branch Name'}
                        </p>
                        <p className="p-0 m-0 fs-12 fw-400 fc-292D32 ff-Akkurat">
                          {'203A Spanish Tn Rd, Kingston'}
                        </p>
                      </Col>
                    )}

                    <Col lg={2} md={6} sm={12}>
                      <Stack
                        direction="horizontal"
                        gap={2}
                        className="items-center"
                      >
                        <img
                          src={mail}
                          alt="icon"
                          style={{ height: '20px', width: '20px' }}
                        />
                        <p
                          className="p-0 m-0 fs-12 fc-292D32 fw-400 ff-Akkurat cursor-pointer"
                          onClick={() => handleCopy(key?.email)}
                          title="Click to copy"
                        >
                          {key?.email}
                        </p>
                      </Stack>
                    </Col>

                    <Col lg={2} md={6} sm={12}>
                      <Stack
                        direction="horizontal"
                        gap={2}
                        className="items-center"
                      >
                        <img
                          src={call}
                          alt="icon"
                          style={{ height: '20px', width: '20px' }}
                        />
                        <p
                          className="p-0 m-0 fs-12 fc-292D32 fw-400 ff-Akkurat cursor-pointer"
                          onClick={() => handleCopy(key?.contact_number)}
                          title="Click to copy"
                        >
                          {key?.contact_number}
                        </p>
                      </Stack>
                    </Col>

                    <Col lg={1} md={6} sm={12}>
                      <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat">
                        {key?.created_at
                          ? moment(key?.created_at).format('DD MMM YYYY')
                          : ''}
                      </p>
                    </Col>

                    <Col lg={1} md={6} sm={12}>
                      <SwitchInput
                        label={true}
                        checked={
                          key?.invite_status === 'specialist-activated'
                            ? true
                            : false
                        }
                        onChange={() => handleSwitchChange(key)}
                        color="secondary"
                      />
                    </Col>

                    <Col
                      lg={`${userRole === 'company-admin' ? 2 : 4}`}
                      md={6}
                      sm={12}
                    >
                      <Stack
                        direction="horizontal"
                        gap={3}
                        className="items-center"
                        // onClick={() =>
                        //   userRole === 'company-admin'
                        //     ? navigate(
                        //         superAdminCompanyProviderDetails(locale),
                        //         { state: { data: key } }
                        //       )
                        //     : userRole === 'salon-admin'
                        //       ? navigate(
                        //           superAdminSalonProviderDetails(locale),
                        //           { state: { data: key } }
                        //         )
                        //       : navigate(
                        //           superAdminSpecialistProviderDetails(locale),
                        //           { state: { data: key } }
                        //         )
                        // }
                      >
                        <img
                          src={trash}
                          alt="icon"
                          style={{ height: '24px', width: '24px' }}
                        />
                        <Stack
                          direction="horizontal"
                          gap={2}
                          className="items-center cursor-pointer"
                          onClick={() =>
                            navigate(
                              superAdminSpecialistProviderDetails(locale),
                              { state: { data: key } }
                            )
                          }
                        >
                          <p className="p-0 m-0 fs-14 fc-292D32 fw-400 ff-Akkurat_Bold underline underline-offset-4">
                            <FormattedMessage id="View Details" />
                          </p>
                          <img
                            src={rightArrow}
                            alt="icon"
                            style={{ height: '20px', width: '20px' }}
                          />
                        </Stack>
                      </Stack>
                    </Col>
                  </Row>
                ))
              ) : (
                <Row className="bc-FFFFFF m-0 p-50 flex justify-center items-center">
                  <Lottie
                    animationData={animationData}
                    loop={true}
                    style={{ height: '200px', width: '200px' }}
                  />
                </Row>
              )}
            </Row>
          </>
        )}

        {tab === 2 && (
          <>
            <Row className="mt-3 listHeader m-0 p-0 flex items-center">
              <Col lg={3} md={6} sm={12}>
                <p
                  className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold d-flex cursor-pointer"
                  onClick={() => handleSort('name')}
                >
                  <FormattedMessage id="Specialist" />
                  {renderSortArrow('name')}
                </p>
              </Col>
              <Col lg={2} md={6} sm={12}>
                <p
                  className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold d-flex cursor-pointer"
                  onClick={() => handleSort('email')}
                >
                  <FormattedMessage id="Email" />
                  {renderSortArrow('email')}
                </p>
              </Col>
              <Col lg={2} md={6} sm={12}>
                <p
                  className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold d-flex cursor-pointer"
                  onClick={() => handleSort('phone')}
                >
                  <FormattedMessage id="Phone Number" />
                  {renderSortArrow('phone')}
                </p>
              </Col>
              <Col lg={2} md={6} sm={12}>
                <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold">
                  <FormattedMessage id="Joined On" />
                </p>
              </Col>
              <Col lg={1} md={6} sm={12}>
                <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold">
                  <FormattedMessage id="Status" />
                </p>
              </Col>
              <Col lg={2} md={6} sm={12}>
                <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold">
                  <FormattedMessage id="Actions" />
                </p>
              </Col>
            </Row>

            <Row className="bc-FFFFFF m-0 p-0">
              {specialistLoading || branchLoading ? (
                <>
                  {[1, 2, 3, 4, 5].map((item) => (
                    <Row
                      key={item}
                      className="m-0 p-0 flex items-center listAppointment"
                    >
                      <Col lg={3} md={6} sm={12}>
                        <ShimmerBox width="150px" height="14px" />
                      </Col>
                      <Col lg={3} md={6} sm={12}>
                        <ShimmerBox width="120px" height="12px" />
                        <ShimmerBox
                          width="100px"
                          height="12px"
                          className="mt-2"
                        />
                      </Col>
                      <Col lg={2} md={6} sm={12}>
                        <ShimmerBox width="100px" height="14px" />
                      </Col>
                      <Col lg={2} md={6} sm={12}>
                        <ShimmerBox width="80px" height="14px" />
                      </Col>
                      <Col lg={2} md={6} sm={12}>
                        <ShimmerBox width="24px" height="24px" />
                      </Col>
                    </Row>
                  ))}
                </>
              ) : specialistList?.length > 0 ? (
                specialistList.map((key, index) => (
                  <Row className="m-0 p-0 flex items-center listAppointment">
                    <Col lg={3} md={6} sm={12}>
                      <p
                        className="p-0 m-0 fs-14 fc-292D32 fw-400 ff-Akkurat_Bold cursor-pointer"
                        onClick={() => handleCopy(key?.name)}
                        title="Click to copy"
                      >
                        {key?.name}
                      </p>
                    </Col>

                    <Col lg={2} md={6} sm={12}>
                      <Stack
                        direction="horizontal"
                        gap={2}
                        className="items-center"
                      >
                        <img
                          src={mail}
                          alt="icon"
                          style={{ height: '20px', width: '20px' }}
                        />
                        <p
                          className="p-0 m-0 fs-12 fc-292D32 fw-400 ff-Akkurat cursor-pointer"
                          onClick={() => handleCopy(key?.email)}
                          title="Click to copy"
                        >
                          {key?.email}
                        </p>
                      </Stack>
                    </Col>

                    <Col lg={2} md={6} sm={12}>
                      <Stack
                        direction="horizontal"
                        gap={2}
                        className="items-center"
                      >
                        <img
                          src={call}
                          alt="icon"
                          style={{ height: '20px', width: '20px' }}
                        />
                        <p
                          className="p-0 m-0 fs-12 fc-292D32 fw-400 ff-Akkurat cursor-pointer"
                          onClick={() => handleCopy(key?.contact_number)}
                          title="Click to copy"
                        >
                          {key?.contact_number}
                        </p>
                      </Stack>
                    </Col>

                    <Col lg={2} md={6} sm={12}>
                      <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat">
                        {key?.created_at
                          ? moment(key?.created_at).format('DD MMM YYYY')
                          : ''}
                      </p>
                    </Col>

                    <Col lg={1} md={6} sm={12}>
                      <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat">
                        {key?.invite_status}
                      </p>
                    </Col>

                    <Col lg={2} md={6} sm={12}>
                      {/* <p
                        className={`p-0 m-0 fs-14 fw-400 ${!key?.cancel_invitation ? 'fc-AF3C29 ff-Akkurat cursor-pointer' : 'fc-1E1E1E ff-Akkurat_Bold'}`}
                        onClick={() =>
                          !key?.cancel_invitation
                            ? handleConfirmCancelInvitation(key?.id)
                            :
                              ''
                        }
                      >
                        {!key?.cancel_invitation ? (
                          <FormattedMessage id="Cancel Invitation" />
                        ) : (
                          <FormattedMessage id="Cancelled" />
                        )}
                      </p> */}
                      <div>
                        <MoreVertIcon
                          aria-describedby={id}
                          style={{ fill: '#3C1053', cursor: 'pointer' }}
                          onClick={(e) => handlePopoverClick(e, key)}
                        />
                        <CustomPopover
                          id={id}
                          open={open}
                          anchorEl={anchorEl}
                          handleClose={handlePopoverClose}
                          options={PopoverData}
                        />
                      </div>
                    </Col>
                  </Row>
                ))
              ) : (
                <Row className="bc-FFFFFF m-0 p-50 flex justify-center items-center">
                  <Lottie
                    animationData={animationData}
                    loop={true}
                    style={{ height: '200px', width: '200px' }}
                  />
                </Row>
              )}
            </Row>
          </>
        )}
      </Col>
    </Row>
  );
};

export default ProviderAdminSpecialists;
